/* One refresh per BROWSER, not one per tab. */

const LOCK_NAME = "trvx-refresh";

/** In-tab fallback for browsers without Web Locks, and a same-tab guard. */
let inFlight = null;

const hasWebLocks = () =>
  typeof navigator !== "undefined" &&
  navigator.locks &&
  typeof navigator.locks.request === "function";

/* Run `work` under the cross-tab refresh lock. */
export const withRefreshLock = async (work) => {
  if (inFlight) return inFlight;

  const run = async () => {
    if (!hasWebLocks()) return work();

    try {
      return await navigator.locks.request(LOCK_NAME, work);
    } catch {
      // A lock can be rejected if the page is being torn down. Doing the work
      // unlocked is better than failing the request outright.
      return work();
    }
  };

  inFlight = run().finally(() => {
    inFlight = null;
  });

  return inFlight;
};

/** Test seam. */
export const __resetRefreshLock = () => {
  inFlight = null;
};
